<template>
    <div class="flex-page-data">
        <div class="flex-page-data__form">
            <section>
                <h2 class="flex-form__section-title">
                    Item Data
                </h2>

                <label class="flex-form__field">
                    <div class="flex-form__label">
                        Item Name
                    </div>

                    <input
                        v-model="name"
                        class="flex-form__input"
                        type="text"
                        :disabled="editMode"
                    >
                </label>

                <label v-if="templateName" class="flex-form__field">
                    <div class="flex-form__label">
                        Template Name
                    </div>

                    <input
                        v-model="templateName"
                        class="flex-form__input"
                        type="text"
                        disabled="disabled"
                    >
                </label>
            </section>

            <section>
                <h2 class="flex-form__section-title">
                    Search Content
                </h2>

                <label class="flex-form__field">
                    <div class="flex-form__label">
                        Main Title
                    </div>

                    <input
                        v-model="mainTitle"
                        class="flex-form__input"
                        type="text"
                    >
                </label>

                <label class="flex-form__field">
                    <div class="flex-form__label">
                        Article Summary
                    </div>

                    <textarea
                        id="article-summary"
                        v-model="articleSummary"
                        class="flex-form__textarea"
                        name="summary"
                        cols="30"
                        rows="10"
                    />
                </label>
            </section>

            <section>
                <h2 class="flex-form__section-title">
                    Metadata
                </h2>

                <label class="flex-form__field">
                    <div class="flex-form__label">
                        Browser Title
                    </div>

                    <input
                        v-model="browserTitle"
                        class="flex-form__input"
                        type="text"
                    >
                </label>

                <label class="flex-form__field">
                    <div class="flex-form__label">
                        Meta Description
                    </div>

                    <textarea
                        id="meta-description"
                        v-model="metaDescription"
                        class="flex-form__textarea"
                        name="meta-description"
                    />
                </label>

                <label class="flex-form__field">
                    <div class="flex-form__label">
                        Meta Keywords
                    </div>

                    <textarea
                        id="meta-keywords"
                        v-model="metaKeywords"
                        class="flex-form__textarea"
                        name="meta-keywords"
                    />
                </label>

                <div class="flex-form__toggle">
                    <div class="flex-form__toggle-control">
                        <toggle v-model="isPrototype" />
                    </div>

                    <div class="flex-form__toggle-text">
                        Is Prototype - Set this page as a prototype to be used by other pages
                    </div>
                </div>

                <div class="flex-form__toggle">
                    <div class="flex-form__toggle-control">
                        <toggle v-model="noIndex" />
                    </div>

                    <div class="flex-form__toggle-text">
                        NoIndex - NOINDEX tag tells crawlers not to index a specific page
                    </div>
                </div>

                <div class="flex-form__toggle">
                    <div class="flex-form__toggle-control">
                        <toggle v-model="noFollow" />
                    </div>

                    <div class="flex-form__toggle-text">
                        NoFollow - NOFOLLOW tag tells crawlers not to follow the links on a specific page
                    </div>
                </div>

                <div class="flex-form__toggle">
                    <div class="flex-form__toggle-control">
                        <toggle v-model="noArchive" />
                    </div>

                    <div class="flex-form__toggle-text">
                        NoArchive - NOFOLLOW tag tells crawlers not to store a cached copy of your page
                    </div>
                </div>

                <div class="flex-form__toggle">
                    <div class="flex-form__toggle-control">
                        <toggle v-model="noSnippet" />
                    </div>

                    <div class="flex-form__toggle-text">
                        NoSnippet - NOFOLLOW tag tells crawlers not to show a snippet (description) under your listing,
                        it will also not show a cached link in the search results
                    </div>
                </div>
            </section>

            <section>
                <h2 class="flex-form__section-title">Styling</h2>

                <label class="flex-form__field">
                    <div class="flex-form__label">
                        Body classes
                    </div>

                    <input
                        v-model="bodyClasses"
                        class="flex-form__input"
                        type="text"
                    >
                </label>
            </section>
        </div>

        <div class="flex-page-data__buttons">
            <button
                class="flex-page-data__button flex-page-data__button--continue"
                @click="save"
            >
                {{ submitButtonText }}
            </button>

            <button
                class="flex-page-data__button flex-page-data__button--cancel"
                @click="cancel"
            >
                CANCEL
            </button>
        </div>
    </div>
</template>

<script>
import { PageData } from '@/data/data-models';

export default {
    name: 'page-data',

    props: {
        submitButtonText: {
            type: String,
            default: 'SAVE',
        },

        data: {
            type: Object,
            default: () => ({}),
        },

        editMode: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            name: '',
            templateName: '',
            articleSummary: '',
            mainTitle: '',
            browserTitle: '',
            metaDescription: '',
            metaKeywords: '',
            bodyClasses: '',
            isPrototype: false,
            noIndex: false,
            noFollow: false,
            noArchive: false,
            noSnippet: false,
        };
    },

    watch: {
        data(val) {
            this.setData(val);
        },
    },

    beforeMount() {
        this.setData(this.data);
    },

    methods: {
        save() {
            this.$emit('save', new PageData({
                name: this.name,
                articleSummary: this.articleSummary,
                mainTitle: this.mainTitle,
                browserTitle: this.browserTitle,
                metaDescription: this.metaDescription,
                metaKeywords: this.metaKeywords,
                bodyClasses: this.bodyClasses,
                isPrototype: this.isPrototype,
                noIndex: this.noIndex,
                noFollow: this.noFollow,
                noArchive: this.noArchive,
                noSnippet: this.noSnippet,
            }));
        },

        cancel() {
            this.$emit('cancel');
        },

        setData(data) {
            this.name = data.name;
            this.templateName = data.templateName;
            this.articleSummary = data.articleSummary;
            this.mainTitle = data.mainTitle;
            this.browserTitle = data.browserTitle;
            this.metaDescription = data.metaDescription;
            this.metaKeywords = data.metaKeywords;
            this.bodyClasses = data.bodyClasses;
            this.isPrototype = data.isPrototype;
            this.noIndex = data.noIndex;
            this.noFollow = data.noFollow;
            this.noArchive = data.noArchive;
            this.noSnippet = data.noSnippet;
        },
    },
};
</script>
